import React from "react";
import {Alert, Snackbar} from "@mui/material";

export default function DashboardSnackbar({toast, onClose}) {
    return (
        <Snackbar
            open={toast.open}
            autoHideDuration={2500}
            onClose={onClose}
            anchorOrigin={{vertical: "bottom", horizontal: "center"}}
        >
            <Alert onClose={onClose} severity={toast.severity} variant="filled" sx={{width: "100%"}}>
                {toast.msg}
            </Alert>
        </Snackbar>
    );
}
